"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FulfillmentShipmentStatus = exports.FulfillmentShipmentError = exports.FulfillmentShipmentWarning = exports.FulfillmentShipmentShippingPriority = exports.FulfillmentShipmentTag = void 0;
var FulfillmentShipmentTag;
(function (FulfillmentShipmentTag) {
    FulfillmentShipmentTag["AUTOMATIC_EARLY_RELEASE"] = "AUTOMATIC_EARLY_RELEASE";
    FulfillmentShipmentTag["BRANDED_SHIPMENT"] = "BRANDED_SHIPMENT";
    FulfillmentShipmentTag["MANUAL_EARLY_RELEASE"] = "MANUAL_EARLY_RELEASE";
    FulfillmentShipmentTag["SIGNATURE_REQUIRED"] = "SIGNATURE_REQUIRED";
})(FulfillmentShipmentTag = exports.FulfillmentShipmentTag || (exports.FulfillmentShipmentTag = {}));
var FulfillmentShipmentShippingPriority;
(function (FulfillmentShipmentShippingPriority) {
    FulfillmentShipmentShippingPriority["URGENT_PRIORITY"] = "URGENT_PRIORITY";
    FulfillmentShipmentShippingPriority["HIGH_PRIORITY"] = "HIGH_PRIORITY";
    FulfillmentShipmentShippingPriority["MEDIUM_PRIORITY"] = "MEDIUM_PRIORITY";
    FulfillmentShipmentShippingPriority["LOW_PRIORITY"] = "LOW_PRIORITY";
})(FulfillmentShipmentShippingPriority = exports.FulfillmentShipmentShippingPriority || (exports.FulfillmentShipmentShippingPriority = {}));
var FulfillmentShipmentWarning;
(function (FulfillmentShipmentWarning) {
    FulfillmentShipmentWarning["CANNOT_USE_PREPURCHASED_LABEL"] = "CANNOT_USE_PREPURCHASED_LABEL";
    FulfillmentShipmentWarning["INVALID_REPLACEMENT_SHIPMENT"] = "INVALID_REPLACEMENT_SHIPMENT";
    FulfillmentShipmentWarning["LATE_PROCESSING_DELAY"] = "LATE_PROCESSING_DELAY";
    FulfillmentShipmentWarning["MARKED_SHIPPED_FROM_OUTBOUND_SCANS"] = "MARKED_SHIPPED_FROM_OUTBOUND_SCANS";
    FulfillmentShipmentWarning["MARKED_SHIPPED_FROM_SC_SCANS"] = "MARKED_SHIPPED_FROM_SC_SCANS";
    FulfillmentShipmentWarning["NOT_CANCELLED_AT_WAREHOUSE"] = "NOT_CANCELLED_AT_WAREHOUSE";
    FulfillmentShipmentWarning["REPLACEMENT_SHIPMENT"] = "REPLACEMENT_SHIPMENT";
    FulfillmentShipmentWarning["SHIPPED_ON_CANCELLED_LABEL"] = "SHIPPED_ON_CANCELLED_LABEL";
    FulfillmentShipmentWarning["UNABLE_TO_CREATE_REPLACEMENT_MORE_THAN_ONE_PACKAGE"] = "UNABLE_TO_CREATE_REPLACEMENT_MORE_THAN_ONE_PACKAGE";
    FulfillmentShipmentWarning["UNABLE_TO_CREATE_REPLACEMENT_NO_INVENTORY"] = "UNABLE_TO_CREATE_REPLACEMENT_NO_INVENTORY";
    FulfillmentShipmentWarning["UNABLE_TO_CREATE_REPLACEMENT_NO_INVENTORY_AT_SAME_SC"] = "UNABLE_TO_CREATE_REPLACEMENT_NO_INVENTORY_AT_SAME_SC";
    FulfillmentShipmentWarning["UNABLE_TO_CREATE_REPLACEMENT_SHIPPING_METHOD_INACTIVE"] = "UNABLE_TO_CREATE_REPLACEMENT_SHIPPING_METHOD_INACTIVE";
    FulfillmentShipmentWarning["UNABLE_TO_CREATE_REPLACEMENT_ZONE_SKIP_SHIPMENT"] = "UNABLE_TO_CREATE_REPLACEMENT_ZONE_SKIP_SHIPMENT";
    FulfillmentShipmentWarning["UNABLE_TO_PREPURCHASE_LABEL"] = "UNABLE_TO_PREPURCHASE_LABEL";
})(FulfillmentShipmentWarning = exports.FulfillmentShipmentWarning || (exports.FulfillmentShipmentWarning = {}));
var FulfillmentShipmentError;
(function (FulfillmentShipmentError) {
    FulfillmentShipmentError["NOT_AT_WAREHOUSE"] = "NOT_AT_WAREHOUSE";
    FulfillmentShipmentError["WAREHOUSE_CANCELLED"] = "WAREHOUSE_CANCELLED";
    FulfillmentShipmentError["WAREHOUSE_DUPLICATE_SHIPMENT"] = "WAREHOUSE_DUPLICATE_SHIPMENT";
    FulfillmentShipmentError["WAREHOUSE_NETWORK_ERR"] = "WAREHOUSE_NETWORK_ERR";
    FulfillmentShipmentError["WAREHOUSE_ON_HOLD_ERR"] = "WAREHOUSE_ON_HOLD_ERR";
    FulfillmentShipmentError["WAREHOUSE_STOCKOUT"] = "WAREHOUSE_STOCKOUT";
    FulfillmentShipmentError["WAREHOUSE_UNKNOWN_ERR"] = "WAREHOUSE_UNKNOWN_ERR";
    FulfillmentShipmentError["DELIVERR_CANCELLED"] = "DELIVERR_CANCELLED";
    FulfillmentShipmentError["DELIVERR_MARKED_LOST"] = "DELIVERR_MARKED_LOST";
    FulfillmentShipmentError["ORDER_CANCELLATION"] = "ORDER_CANCELLATION";
    FulfillmentShipmentError["BAD_ADDRESS"] = "BAD_ADDRESS";
    FulfillmentShipmentError["INVENTORY_OUT_OF_SYNC"] = "INVENTORY_OUT_OF_SYNC";
    FulfillmentShipmentError["STOCKOUT"] = "STOCKOUT";
    FulfillmentShipmentError["UNKNOWN"] = "UNKNOWN";
    FulfillmentShipmentError["PARTIAL_SHIP_UPDATE_FAILED"] = "PARTIAL_SHIP_UPDATE_FAILED";
})(FulfillmentShipmentError = exports.FulfillmentShipmentError || (exports.FulfillmentShipmentError = {}));
var FulfillmentShipmentStatus;
(function (FulfillmentShipmentStatus) {
    FulfillmentShipmentStatus["CREATED"] = "CREATED";
    FulfillmentShipmentStatus["WAREHOUSE"] = "WAREHOUSE";
    FulfillmentShipmentStatus["ERROR"] = "ERROR";
    FulfillmentShipmentStatus["SHIPPED"] = "SHIPPED";
    FulfillmentShipmentStatus["PARTIALLY_SHIPPED"] = "PARTIALLY_SHIPPED";
    FulfillmentShipmentStatus["OVER_SHIPPED"] = "OVER_SHIPPED";
    FulfillmentShipmentStatus["NOT_SYNCED"] = "NOT_SYNCED";
    FulfillmentShipmentStatus["CANCELLED"] = "CANCELLED";
})(FulfillmentShipmentStatus = exports.FulfillmentShipmentStatus || (exports.FulfillmentShipmentStatus = {}));
//# sourceMappingURL=FulfillmentShipment.js.map